import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import {
  getToken,
  removeToken
} from './utils/auth';
import {userinfo} from './apis/https'
import request from './utils/request';
import { loadBrowse, saveBrowse } from './utils/browseAuth'


const preUserInfo = {
  name: '',
  sex: '',
  avatar: '',
  birthday: '',
  introduction: '',
  mobile: '',
  userId: 0,
  follow: 0,
  followUserIds: [],
  fans: 0,
  fansUserIds: [],
  like: 0,
  likeUserIds: [],
  album: [],
  favorite: [],
  study: []
};

export default new Vuex.Store({
  state: {
    userInfo: {
      ...preUserInfo
    },
    qiNiu: {
      domain: '',
      expires: 0,
      key: '',
      token: '',
      upload: '',
      loading: false
    },
    user:{
      img:'',
      name:'',
      sex:'',
      mobile:''
    },
    system: {
      category: [],
      material: [],
      type: [],
      diamond: [],
      brand: [],
      hotKey: [],
      listStyle:"cell",
      shopid:null
    },
    browseHistory: loadBrowse(),
    order:{
      ids:null,
      goods_id:null,
      goods_num:null,
      goods_sku_id:null,
    }
  },
  getters: {
    token: state => {
      if (state.userInfo) {
        return getToken();
      }
    },
    userInfo: state => state.userInfo
  },
  mutations: {
    USER_INFO: (state, payload) => {
      for (let key in payload) {
        state.userInfo[key] = payload[key];
      }
    },
    QI_NIU: (state, payload) => {
      for (let key in payload) {
        state.qiNiu[key] = payload[key];
      }
    },
    SYSTEM: (state, payload) => {
      state.system = payload;
    },
    ORDER: (state, payload) => {
      for (let key in payload) {
        state.order[key] = payload[key];
      }
    },
    LISTSTYLE:(state, payload) =>{
      state.system.listStyle = payload;
    },
    SHOPID:(state, payload) =>{
      state.system.shopid = payload;
    },
    SET_BROWSE_HITORY: (state, history)=>{
      state.browseHistory = history
    },
    SETUSERINFO: (state,payload)=>{
      for (let key in payload) {
        state.user[key] = payload[key];
      }
    }
  },
  actions: {
    // 获取用户信息
    RefreshUserInfo({commit,state}) {
        return new Promise((resolve, reject) => {
          request.post('/api/user_more/info').then(data => {
  
            //fixme:OSS未支持https,兼容处理
            data.avatar = data.avatar.replace(/(https?:)?\/\//, 'http://')
            data.album.forEach((item, i)=>{
              data.album[i].url = item.url.replace(/(https?:)?\/\//, 'http://')
            })
  
            commit('USER_INFO', data);
            resolve(data);
          }).catch(error => {
            reject(error);
          });
        });
    },
    
    // 获取七牛token
    RefreshQiNiu({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        commit('QI_NIU', {loading: true});
        request.post('/api/qiniu/token').then(data => {
          commit('QI_NIU', data);
          commit('QI_NIU', {loading: false});
          resolve(data);
        }).catch(error => {
          commit('QI_NIU', {loading: false});
          reject(error);
        });
      });
    },
    SetUser(content,token){
      return new Promise((resolve,reject)=>{
        userinfo(token).then(res=>{
          var result = {
            name: res.data.nickName,
            img:res.data.avatarUrl,
            sex:res.data.gender,
            mobile:res.data.mobile
          }
          content.commit('SETUSERINFO',result);
          resolve(result);
        }).catch(e => {
          reject(e)
        })
      })
    },
    GetSystem({commit}) {
      return new Promise((resolve, reject) => {
        request.get('/api/config').then(data => {
          commit('SYSTEM', data);
          resolve(data);
        }).catch(error => {
          reject(error);
        });
      });
    },

    LogOut({ commit}) {
      return new Promise((resolve, reject) => {
        // 清除token等操作
        commit('USER_INFO', {
          ...preUserInfo
        });
        removeToken();
        resolve();
      });
    },

    //保存浏览历史
    saveBrowsehHistory({commit},query) {
      commit('SET_BROWSE_HITORY',saveBrowse(query))
    },
  }
});